import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from '../telescope.png';

interface Props {
  handleToggle: any;
  authenticateUser: any;
  authenticated: any;
}

const AppHeader = ({
  handleToggle,
  authenticateUser,
  authenticated,
}: Props) => {
  return (
    <div className='App'>
      <header className='App-header'>
        <img src={logo} className='App-logo' alt='logo' />
        <h1 className='App-title'>Dataskop - Backend Configurator</h1>
        <div className='App-controls'>
          <span>Project Level</span>
          <div className='checkbox-wrapper-41'>
            <input type='checkbox' onChange={handleToggle} />
          </div>
          <span>Device Level</span>
        </div>
        <p className='App-intro'>
          Detailed instructions under:{' '}
          <a
            className='App-link'
            href='https://git.nwt.fhstp.ac.at/dataskop/dataskop-ar/-/wikis/Additional-property-setup-%28backend%29'
          >
            Dataskop Wiki
          </a>
          <span
            style={{
              fontSize: '2.0em',
              lineHeight: '0',
              fontWeight: 'bolder',
              margin: '0 10px',
            }}
          >
            |
          </span>
          Download the backend tool from:{' '}
          <a className='App-link' href='https://backend.dataskop.at/'>
            Backend Tool
          </a>
        </p>
        <div className='floating-login-button'>
          {authenticated ? (
            <Tooltip title='Logout'>
              <IconButton color='primary' onClick={authenticateUser}>
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title='Login'>
              <IconButton color='primary' onClick={authenticateUser}>
                <LoginIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </header>
    </div>
  );
};

export default AppHeader;
